import { render } from "./SkeletonTablas.vue?vue&type=template&id=32a09353&scoped=true"
import script from "./SkeletonTablas.vue?vue&type=script&lang=js"
export * from "./SkeletonTablas.vue?vue&type=script&lang=js"

import "./SkeletonTablas.vue?vue&type=style&index=0&id=32a09353&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a09353"]])

export default __exports__